module.exports = __webpack_public_path__ + "static/media/storytelling-bg-mob.37e4f75b.svg";